<template>
  <ag-card :module="module"></ag-card>
  
  <div role="document">
      <div class="modal-content">
        <Form
          @submit="onSubmit"
          autocomplete="off"
          ref="form"
          :key="compKey"
         
          :initial-values="formValues"
          v-slot="{ meta }"
        >
          <input
            autocomplete="false"
            name="hidden"
            type="text"
            style="display: none"
          />
          <div class="modal-body">
            <div class="ag-modal-form w-100">
              <ul class="ag-modal-form-list">
                <li v-if="isAllowedFor('PolicyPollingInterval')">
                  <span class="bold-text">{{ $t("policyPollingInterval") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="pollingInterval" v-slot="{ field, meta }">
                        <input
                          type="number"
                          name="pollingInterval"
                          @change="pollingIntervalValue"
                          @input="limitLengthpollingInterval($event)"
                          v-model="formValues.pollingInterval"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="pollingInterval"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('LogPostingInterval')">
                  <span class="bold-text">{{ $t("logPostingInterval") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="loggingInterval" v-slot="{ field, meta }">
                        <input
                          type="number"
                          name="url"
                          @change="loggingIntervalValue"
                          @input="limitLengthloggingInterval($event)"
                          v-model="formValues.loggingInterval"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="loggingInterval"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('MaxLogFolderSize')">
                  <span class="bold-text">{{ $t("maxLogFolderSize") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="maxLogFolderSize" v-slot="{ field, meta }">
                        <input
                          type="number"
                          name="maxLogFolderSize"
                          @change="maxLogFolderSizeValue"
                          v-model="formValues.maxLogFolderSize"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="maxLogFolderSize"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('LogSeverity')">
                  <span class="bold-text">{{ $t("logSeverity") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="" v-slot="{ field, meta }">
                        <select
                          name="logSeverity"
                          v-model="formValues.logSeverity"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        >
                        <option
                          v-for="(item, key) in logSeverityOptions"
                          :key="item"
                          :value="key"
                        >
                          {{ item }}
                        </option>
                      </select>
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="logSeverity"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('AdminModeRequired')">
                  <span class="bold-text">{{ $t("adminReqChangingLogSeverity") }} : </span>
                  <span class="value">
                    <li class="form-group">
                      <Field name="authRequiredChangeLogSeverity">
                        <input
                          type="checkbox"
                          v-model="formValues.authRequiredChangeLogSeverity"
                          :checked="formValues.authRequiredChangeLogSeverity"
                        />
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('SummaryMode')">
                  <span class="bold-text">{{ $t("summaryMode") }} : </span>
                  <span class="value">
                    <li class="form-group">
                      <Field name="bVerboseMode">
                        <input
                          type="checkbox"
                          v-model="formValues.bVerboseMode"
                          :checked="formValues.bVerboseMode"
                        />
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('EncryptionMethod')">
                  <span class="bold-text">{{ $t("encryptionMethod") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="" v-slot="{ field, meta }">
                        <select
                          name="encryptionType"
                          v-model="formValues.encryptionType"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        >
                        <option
                          v-for="(item, key) in encryptionMethodOptions"
                          :key="item"
                          :value="key"
                        >
                          {{ item }}
                        </option>
                      </select>
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="encryptionType"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('EnableProcessHashReporting')">
                  <span class="bold-text">{{ $t("processHashReporting") }} : </span>
                  <span class="value">
                    <li class="form-group">
                      <Field name="bReportHashForBlockingEvents">
                        <input
                          type="checkbox"
                          v-model="formValues.bReportHashForBlockingEvents"
                          :checked="formValues.bReportHashForBlockingEvents"
                        />
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('EnableProcessTreeReporting')">
                  <span class="bold-text">{{ $t("processTreeReporting") }} : </span>
                  <span class="value">
                    <li class="form-group">
                      <Field name="bReportProcessTreeForBlockingEvents">
                        <input
                          type="checkbox"
                          v-model="formValues.bReportProcessTreeForBlockingEvents"
                          :checked="formValues.bReportProcessTreeForBlockingEvents"
                        />
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('EnablePublisherInfoReporting')">
                  <span class="bold-text">{{ $t("publisherInfoReporting") }} : </span>
                  <span class="value">
                    <li class="form-group">
                      <Field name="bReportPublisherInfoForBlockingEvents">
                        <input
                          type="checkbox"
                          v-model="formValues.bReportPublisherInfoForBlockingEvents"
                          :checked="formValues.bReportPublisherInfoForBlockingEvents"
                        />
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('ReportPublisherInfoForScripts')">
                  <span class="bold-text">{{ $t("publisherInfoForScriptsReporting") }} : </span>
                  <span class="value">
                    <li class="form-group">
                      <Field name="reportPublisherInfoForScripts">
                        <input
                          type="checkbox"
                          v-model="formValues.reportPublisherInfoForScripts"
                          :checked="formValues.reportPublisherInfoForScripts"
                        />
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('ReportPublisherInfoForCodeload')">
                  <span class="bold-text">{{ $t("publisherInfoForCodeloadReporting") }} : </span>
                  <span class="value">
                    <li class="form-group">
                      <Field name="reportPublisherInfoForCodeload">
                        <input
                          type="checkbox"
                          v-model="formValues.reportPublisherInfoForCodeload"
                          :checked="formValues.reportPublisherInfoForCodeload"
                        />
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('EncryptLogs')">
                  <span class="bold-text">{{ $t("encryptLogs") }} : </span>
                  <span class="value">
                    <li class="form-group">
                      <Field name="encryptPolicyLog">
                        <input
                          type="checkbox"
                          v-model="formValues.encryptPolicyLog"
                          :checked="formValues.encryptPolicyLog"
                        />
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('DebugLogExpirationTime')">
                  <span class="bold-text" v-html="`${$t('debugLogExpirationTime')}<br><span style='color: grey; font-size: 0.9em;'>${$t('debugLogExpirationTimeExp')}</span>:`"></span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="debugLogExpirationTime" v-slot="{ field, meta }">
                        <input
                          type="number"
                          name="debugLogExpirationTime"
                          v-model="formValues.debugLogExpirationTime"
                          @input="debugLogExpirationTimeValue"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="debugLogExpirationTime"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('DebugLogSeverity')">
                  <span class="bold-text">{{ $t("debugLogSeverity") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="debugLogSeverity" v-slot="{ field, meta }">
                        <input
                          type="number"
                          name="debugLogSeverity"
                           @input="debugLogSeverityValue"
                          v-model="formValues.debugLogSeverity"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="debugLogSeverity"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="isAllowedFor('DebugLogFolderSize')">
                  <span class="bold-text" v-html="`${$t('debugLogFolderSize')}<br><span style='color: grey; font-size: 0.9em;'>${$t('debugLogFolderSizeExp')}</span>:`"></span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="debugLogFolderSize" v-slot="{ field, meta }">
                        <input
                          type="number"
                          name="debugLogFolderSize"
                           @change="debugLogFolderSizeValue"
                           @input="limitLengthDebugFolderSize($event)"
                          v-model="formValues.debugLogFolderSize"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="debugLogFolderSize"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button
              type="button"
              class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_secondary"
              @click="router.push('/settings/pdp-lrp-list')"
              data-dismiss="modal"
            >
            {{ $t("cancel") }}
            </button>
            <div>
              <button
                  v-if="isModified"
                  type="button"
                  :disabled="loading"
                  class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_primary mr-2"
                  @click="resetToDefault"
              >
              {{ $t("resetToDefault") }}
              </button>
              <button
                  type="submit"
                  :disabled="!meta.valid || loading"
                  class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_primary"
              >
              {{ $t("save") }}
              </button>
            </div>
          </div>
        </Form>
      </div>
    </div>
</template>

<script>
import { defineComponent, toRaw  } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import PdpLrpSettings from "@/helpers/pages/PdpLrpSettings";
import AgLoading from "@/components/ag-loading/index.vue";
import { Roles } from "@/helpers/enums/Roles";
import { Field, Form, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useStore } from "@/store"; 
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import apiAGSC from "@/store/axiosAgsc";
import { notify } from "@kyvg/vue3-notification";
import Swal from "sweetalert2";
import isEqual from "lodash/isEqual";
import { useRouter } from "vue-router";

const store = useStore();

export default defineComponent({
  name: "PdpLrpSettings",
  components: { AgCard, Form, Field },
  setup() {
    const router = useRouter();
    return { router };
  },
  data() {
    const rolePermissions = {
      PolicyPollingInterval: [Roles.AGMSAdmin,Roles.PartnerAdmin, Roles.CompanyAdmin],
      LogPostingInterval: [Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin],
      MaxLogFolderSize: [Roles.AGMSAdmin, Roles.PartnerAdmin],
      LogSeverity: [Roles.AGMSAdmin,Roles.PartnerAdmin],
      AdminModeRequired: [Roles.PartnerAdmin],
      SummaryMode: [Roles.AGMSAdmin, Roles.PartnerAdmin],
      EncryptionMethod: [Roles.AGMSAdmin],
      EnableProcessHashReporting: [Roles.AGMSAdmin],
      EnableProcessTreeReporting: [Roles.AGMSAdmin],
      EnablePublisherInfoReporting: [Roles.AGMSAdmin],
      ReportPublisherInfoForScripts: [Roles.AGMSAdmin],
      ReportPublisherInfoForCodeload: [Roles.AGMSAdmin],
      EncryptLogs: [Roles.AGMSAdmin, Roles.PartnerAdmin],
      DebugLogExpirationTime: [Roles.AGMSAdmin, Roles.PartnerAdmin,Roles.CompanyAdmin],
      DebugLogSeverity: [Roles.AGMSAdmin, Roles.PartnerAdmin,Roles.CompanyAdmin],
      DebugLogFolderSize: [Roles.AGMSAdmin, Roles.PartnerAdmin,Roles.CompanyAdmin],
    };
       // const schema = Yup.object().shape({
    //       pollingInterval: Yup.string().required().label(this.$t("policyPollingInterval")),
    //       loggingInterval: Yup.string().required().label(this.$t("logPostingInterval")),
    //       maxLogFolderSize: Yup.string().required().label(this.$t("maxLogFolderSize")),
    // });
      return {
          module: PdpLrpSettings,
          selectedRole:null,
          rolePermissions,
          Roles: Roles,
           // schema,
          loading: false,
          logSeverityOptions: { 1: "Lowest (1)", 2: "Low (2)", 3: "Medium (3)", 4: "High (4)", 5: "Critical (5)" },
          encryptionMethodOptions: { 1: "AES 128", 2: "AES 192", 3: "AES 256" },
          defaultValues: {
            pollingInterval: 30,
            loggingInterval: 30,
            maxLogFolderSize: 10,
            logSeverity: 3,
            authRequiredChangeLogSeverity: false,
            bVerboseMode: true,
            encryptionType: 1,
            bReportHashForBlockingEvents: true,
            bReportProcessTreeForBlockingEvents: true,
            bReportPublisherInfoForBlockingEvents: true,
            reportPublisherInfoForScripts:true,
            reportPublisherInfoForCodeload:true,
            encryptPolicyLog: true,
            debugLogExpirationTime: 0,
            debugLogSeverity: 3,
            debugLogFolderSize: 10
          },
          formValues: {
              pollingInterval: null,
              loggingInterval: null,
              maxLogFolderSize: null,
              logSeverity: null,
              authRequiredChangeLogSeverity: false,
              bVerboseMode: false,
              encryptionType: null,
              bReportHashForBlockingEvents: false,
              bReportProcessTreeForBlockingEvents: false,
              bReportPublisherInfoForBlockingEvents: false,
              reportPublisherInfoForScripts: true,
              reportPublisherInfoForCodeload: true,
              encryptPolicyLog: false,
              debugLogExpirationTime: null,
              debugLogSeverity: null,
              debugLogFolderSize: null
          }
      };
  },
  computed: {
    compKey() {
        return store.getters.compKey;
    },
    isModified() {
      const filteredFormValues = Object.fromEntries(
        Object.entries(toRaw(this.formValues)).filter(([key]) => key in this.defaultValues)
      );
      const isDifferent = !isEqual(filteredFormValues, this.defaultValues);
      return isDifferent;
    },
    
  },
  async created() {
    if (typeof localStorage !== "undefined") {
      this.selectedRole = localStorage.getItem("selectedRole");
      this.realRole = localStorage.getItem("realRole");
    }
    this.getList();
  },
  watch: {
    compKey() {
      this.formValues = {
        policyPollingInterval: 30,
        logPostingInterval: 30,
        maxLogFolderSize: 10,
        logSeverity: 4,
        adminReqChangingLogSeverity: false,
        summaryMode: true,
        encryptionMethod: 1,
        processHashReporting: true,
        processTreeReporting: true,
        publisherInfoReporting: true,
        reportPublisherInfoForScripts:true,
        reportPublisherInfoForCodeload:true,
        encryptLogs: true,
        debugLogExpirationTime: 0,
        debugLogSeverity: 3,
        debugLogFolderSize: 30
      };
    }
  },
  methods: {
    
  debugLogExpirationTimeValue(e) {
    const value = e.target.value;
    if (value > 48) {
      this.formValues.debugLogExpirationTime = 48;
      e.target.value = 48;
    } else if (value < 0) {
      this.formValues.debugLogExpirationTime = 0;
      e.target.value = 0;
    }
  },
  debugLogSeverityValue(e) {
    const value = e.target.value;
    if (value > 5) {
      this.formValues.debugLogSeverity = 5;
      e.target.value = 5;
    } else if (value < 0) {
      this.formValues.debugLogSeverity = 0;
      e.target.value = 0;
    }
  },
  
  maxLogFolderSizeValue(e) {
    const value = parseInt(e.target.value);
    if (isNaN(value)) return; 

    if (value > 500) {
      this.formValues.maxLogFolderSize = 500;
      e.target.value = 500;
    } else if (value < 10 && e.target.value !== "") {  
      this.formValues.maxLogFolderSize = 10;
      e.target.value = 10;
    }
  
  },
  debugLogFolderSizeValue(e) {
    const value = parseInt(e.target.value);
    if (isNaN(value)) return; 

    if (value > 500) {
      this.formValues.debugLogFolderSize = 500;
      e.target.value = 500;
    } else if (value < 10 && e.target.value !== "") {  
      this.formValues.debugLogFolderSize = 10;
      e.target.value = 10;
    }
  
  },
  pollingIntervalValue(e) {
    const value = parseInt(e.target.value);
    if (isNaN(value)) return; 

    if (value > 10080) {
      this.formValues.pollingInterval = 10080;
      e.target.value = 10080;
    } else if (value < 10 && e.target.value !== "") {  
      this.formValues.pollingInterval = 10;
      e.target.value = 10;
    }
  
  },
  limitLengthpollingInterval(event) {
    const value = event.target.value;
    if (value.length > 5) {
      event.target.value = value.slice(0, 5);
      this.formValues.pollingInterval = event.target.value;
    }
  },
  limitLengthloggingInterval(event) {
    const value = event.target.value;
    if (value.length > 5) {
      event.target.value = value.slice(0, 5);
      this.formValues.loggingInterval = event.target.value;
    }
  },
  limitLengthDebugFolderSize(event) {
    const value = event.target.value;
    if (value.length > 3) {
      event.target.value = value.slice(0, 3);
      this.formValues.debugLogFolderSize = event.target.value;
    }
  },
  loggingIntervalValue(e) {
    const value = parseInt(e.target.value);
    if (isNaN(value)) return; 

    if (value > 10080) {
      this.formValues.loggingInterval = 10080;
      e.target.value = 10080;
    } else if (value < 10 && e.target.value !== "") {  
      this.formValues.loggingInterval = 10;
      e.target.value = 10;
    }
  
  },
  
    isAllowedFor(fieldName) {
      return this.rolePermissions[fieldName]?.includes(this.realRole);
    },
    async getList() {
      const selectedRole = localStorage.getItem("selectedRole");
      const realRole = localStorage.getItem("realRole");
      const selectedScopeId = localStorage.getItem("selectedScopeId");
      const company = localStorage.getItem("company");
      const companyId = company ? JSON.parse(company)?.companyGuid : "";
      const res = await store.dispatch(GeneralActionTypes.GET_OR_CREATE_APPGUARD_MAIN, { companyId, selectedRole,realRole,selectedScopeId });
      this.formValues = res.entityData;
    },
    async resetToDefault() {
      this.loading = true;
      Swal
        .fire({
          title: this.$t('areYouSure'),
          icon: "warning",
          text: this.$t('resetToDefaultWarning'),
          showCancelButton: true,
          confirmButtonText: "Okay",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loading = true;
            try {
              this.formValues.SelectedRole = localStorage.getItem("selectedRole");
              this.formValues.RealRole = localStorage.getItem("realRole");
              this.formValues.SelectedScopeId = localStorage.getItem("selectedScopeId");
              const company = localStorage.getItem("company");
              this.formValues.CompanyId = company ? JSON.parse(company)?.companyGuid : "";

              await store.dispatch(GeneralActionTypes.RESET_TO_DEFAULT_APPGUARD_MAIN, this.formValues);
              this.formValues = { ...this.defaultValues }; 
              this.$refs.form.initialValues = { ...this.defaultValues }; 
              this.$refs.form.resetForm();
              notify({
                title: this.$t('pdpLrpConfUpdated'),
                type: "success",
                duration: 4000,
              });
            } catch (error) {
              notify({
                title: this.$t('errorOccurred'),
                type: "error",
                text: error.message,
                duration: 8000,
              });
            } finally {
              this.loading = false;
              this.$forceUpdate();
            }
          }
          else {
            this.loading = false;
          }
      })
    },
    async onSubmit() {
      this.loading = true;
      const body = { ...this.formValues };  
      body.SelectedRole = localStorage.getItem("selectedRole");
      body.RealRole = localStorage.getItem("realRole");
      const company = localStorage.getItem("company");
      body.selectedScopeId = localStorage.getItem("selectedScopeId");
      body.CompanyId = company ? JSON.parse(company)?.companyGuid : "";
      apiAGSC["post"]("AppGuardMain/UpdateAppGuardMain", body)
        .then(async (res) => {
          let errors = [];
          if (res.status && res.status !== 200 && res.data.errors) {
            errors = res.data.errors;
          } else if (
            res.data.statusCode &&
            res.data.statusCode !== 200 &&
            res.data.errors
          ) {
            errors = res.data.errors;
          }
          if (errors.length > 0) {
            const errorMessage = errors.map((f) => "<li>" + f + "</li>");
            notify({
              title: this.$t('errorOccurred'),
              type: "error",
              text:
                "<p>" +
                res.data.Message +
                "</p>" +
                "<ul>" +
                errorMessage +
                "</ul>",
              duration: 8000,
            });
          } else {
            notify({
              title:this.$t('pdpLrpConfUpdated'),
              type: "success",
              duration: 4000,
            });
            await this.getList();
          }
        })
        .catch((e) => {
          console.log(e);
          if (e && e.errors) {
            const errors = e.errors.map((f) => "<li>" + f + "</li>");
            notify({
              title: this.$t('errorOccurred'),
              type: "error",
              text: "<p>" + e.message + "</p>" + "<ul>" + errors + "</ul>",
              duration: 8000,
            });
          }
        })
        .finally(() => {
          this.loading = false;
          this.$forceUpdate();
        });
    },
  },
});
</script>

<style>
.ag-page_users #ag-table .ag-icon {
  font-size: 1.1em !important;
}
.ag-content {
  margin-bottom: 0%;
}
.ag-modal .modal-body label {
  color: #8e8e8e;
  font-size: 14px;
  margin: 0;
  display: flex;
  align-items: center;
}
.modal-content {
  background-color: #F8F8F8;
  margin-bottom: 1%;
}
.ag-modal-form-list {
  margin-left: 30px;
}

.ag-modal .modal-body label input {
  margin-right: 4px;
}

.ag-modal-form-list li {
  width: 86%;
}

.ag-modal-form-list li .bold-text {
  text-align: left !important;
  width: 33% !important;
}

.error-wrapper {
  display: block;
  width: 100%;
}
li.form-group-full {
  display: flex;
  flex-direction: column;
}
</style>